"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Indicator: {
      '& > .bar-wrap': {
        '& > .bar': {
          backgroundColor: theme['$indicator-grey'],
          height: 4,
          position: 'relative',
          // to contain the .pct-complete bar
          '& .pct-complete': {
            backgroundColor: theme['$indicator-green'],
            position: 'absolute',
            top: 0,
            left: 0,
            height: 4
          }
        },
        '& > .dots': {
          display: 'flex',
          position: 'relative',
          // to remain above the .pct-complete bar
          justifyContent: 'space-between',
          marginLeft: -6,
          marginRight: -6,
          '& > .dot': {
            marginTop: -9,
            // would be great to be possible to use transparent but the bar behind would show up
            backgroundColor: theme['$indicator-green'],
            border: "3px solid ".concat(theme['$indicator-green']),
            height: 7,
            width: 7,
            minWidth: 7,
            // do not distort if there's just one item in the indicator
            borderRadius: 7,
            '&.active': {
              backgroundColor: theme['$indicator-white']
            },
            '&.incomplete': {
              backgroundColor: theme['$indicator-white'],
              borderColor: theme['$indicator-grey']
            }
          }
        }
      },
      '& > .items-wrap': {
        display: 'flex',
        '& > .item': {
          textAlign: 'center',
          flex: 1
        }
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map